import { fetchFromOldApi } from '~/services/Http';

export type Audience = {
  unitAudience: string[];
  roleAudience: string[];
  countryAudience: string[];
};

export type EmployeeFormType = {
  fEmpFormId: number;
  fEmpFormEmpId: number;
  fEmpFormCompFormFK: number;
  fEmpFormCreatedTime: string;
  fEmpFormUpdatedTime: string;
  fEmpFormInfo?: string;
  fEmpFormAttachmentId: number;
  fEmpFormAttachmentName: string;
  fFormAttachment?: File | undefined;
};

export type CompanyFormType = {
  fComFormId: number;
  fComFormName: string;
  fComFormCountry: string;
  fComFormCreatedTime: string;
  fComFormUpdatedTime: string;
  fComFormIsActive: boolean;
  fComFormExpirationDate: string;
  fComFormAttachmentId: number;
  fComFormAttachmentName: string;
  fComFormDescription?: string;
};

export const getEmployeeForms = (iEmpId: string): Promise<EmployeeFormType[]> =>
  fetchFromOldApi(`/json/form/employee/${iEmpId}`).then((r) => r.json());

export const getCompanyForms = (): Promise<CompanyFormType[]> =>
  fetchFromOldApi('/json/form/company').then((r) => r.json());

export const putFormData = async (
  json: FormData | Object,
  iEmpId: number,
  iFormId: number,
) => {
  return await fetchFromOldApi(`/form/form/employee/${iEmpId}/${iFormId}`, {
    method: 'PUT',
    body: json as FormData,
  }).then((r) => r.json());
};

export const postFormData = async (json: FormData | Object, iEmpId: number) => {
  return await fetchFromOldApi(`/form/form/employee/${iEmpId}`, {
    method: 'POST',
    body: json as FormData,
  }).then((r) => r.json());
};

export const deleteForm = async (iEmpId: number, formId: number) => {
  return await fetchFromOldApi(`/json/form/employee/${iEmpId}/${formId}`, {
    method: 'DELETE',
  }).then((r) => r.json());
};
